import types from './appTypes';

const setUser = (payload) => ({
    type: types.SET_USER,
    payload,
});

const setToken = (payload) => ({
    type: types.SET_TOKEN,
    payload,
});

const revokeAccessFE = () => ({
    type: types.REVOKE_ACCESS,
});

const setActiveClient = (payload) => ({
    type: types.SET_ACTIVE_CLIENT,
    payload,
});

const setSideNavPinned = (payload) => ({
    type: types.SET_SIDE_NAV_PINNED,
    payload,
});
const setReadyUpgradeModal = (payload) => ({
    type: types.SHOW_READY_UPGRADE_MODAL,
    payload,
});
const setStartPlanModal = (payload) => ({
    type: types.SHOW_START_PLAN_MODAL,
    payload,
});

export default {
    setUser,
    setToken,
    revokeAccessFE,
    setActiveClient,
    setSideNavPinned,
    setReadyUpgradeModal,
    setStartPlanModal,
};
